const Mutations = Object.freeze({
	SET_PROJECTUSERS:
		'inventoryFormModule/formBuilder/assignUsers/SET_PROJECTUSERS',
	SET_FORMUSERS:
		'inventoryFormModule/formBuilder/assignUsers/SET_SET_FORMUSERS',
	SET_LOADING: 'inventoryFormModule/formBuilder/assignUsers/SET_LOADING',
});
export const Actions = Object.freeze({
	LOAD_PROJECTUSERS:
		'inventoryFormModule/formBuilder/assignUsers/LOAD_PROJECTUSERS',
	LOAD_FORMUSERS:
		'inventoryFormModule/formBuilder/assignUsers/LOAD_FORMUSERS',
	LOAD: 'inventoryFormModule/formBuilder/assignUsers/LOAD',
	INSERT: 'inventoryFormModule/formBuilder/assignUsers/INSERT',
	DELETE: 'inventoryFormModule/formBuilder/assignUsers/DELETE',
});
export const Getters = Object.freeze({
	ASSIGNEDUSERS: 'inventoryFormModule/formBuilder/assignUsers/ASSIGNEDUSERS',
	UNASSIGNEDUSERS:
		'inventoryFormModule/formBuilder/assignUsers/UNASSIGNEDUSERS',
	IS_LOADING: 'inventoryFormModule/formBuilder/assignUsers/IS_LOADING',
});
import dataService from '../../../../../../services/data/inventoryFormService';
import { GeneralActions, InventoryFormActions } from '../../../../../actions';

export default {
	state: {
		projectUsers: [],
		formUsers: [],
		loading: false,
	},

	mutations: {
		[Mutations.SET_PROJECTUSERS](state, items) {
			state.projectUsers = items;
		},
		[Mutations.SET_FORMUSERS](state, items) {
			state.formUsers = items;
		},
		[Mutations.SET_LOADING](state, item) {
			state.loading = item;
		},
	},
	actions: {
		[Actions.LOAD_PROJECTUSERS]({ commit, dispatch }, id) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.getProjectUsers(id)
					.then((resp) => {
						commit(Mutations.SET_PROJECTUSERS, resp.data);
						commit(Mutations.SET_LOADING, false);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						commit(Mutations.SET_LOADING, false);
						resolve();
					});
			});
		},
		[Actions.LOAD_FORMUSERS]({ commit, dispatch }, id) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.getInventoryFormUsers(id)
					.then((resp) => {
						commit(Mutations.SET_FORMUSERS, resp.data);
						commit(Mutations.SET_LOADING, false);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						commit(Mutations.SET_LOADING, false);
						resolve();
					});
			});
		},
		[Actions.LOAD]({ dispatch }, { projectId: projectId, formId: formId }) {
			return Promise.all([
				dispatch(Actions.LOAD_PROJECTUSERS, projectId),
				dispatch(Actions.LOAD_FORMUSERS, formId),
			]);
		},
		[Actions.INSERT]({ commit, dispatch }, { inventoryId, users }) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.insertInventoryFormUser(inventoryId, users)
					.then(() => {
						commit(Mutations.SET_LOADING, false);
						dispatch(InventoryFormActions.RELOAD);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						commit(Mutations.SET_LOADING, false);
						resolve();
					});
			});
		},
		[Actions.DELETE]({ commit, dispatch }, { inventoryId, users }) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				commit(Mutations.SET_LOADING, true);
				dataService
					.deleteInventoryFormUser(inventoryId, users)
					.then(() => {
						commit(Mutations.SET_LOADING, false);
						dispatch(InventoryFormActions.RELOAD);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						commit(Mutations.SET_LOADING, false);
						resolve();
					});
			});
		},
	},
	getters: {
		[Getters.ASSIGNEDUSERS]: (state) => {
			let result = [];
			state.formUsers.forEach((p) => {
				let assigned = state.projectUsers.find(
					(x) => x.UserId == p.UserId
				);
				if (assigned) result.push(p);
			});
			return result.sort((a, b) =>
				a.FirstName.concat(' ', a.LastName).localeCompare(
					b.FirstName.concat(' ', b.LastName)
				)
			);
		},
		[Getters.UNASSIGNEDUSERS]: (state) => {
			let result = [];
			state.projectUsers.forEach((p) => {
				let assigned = state.formUsers.find(
					(x) => x.UserId == p.UserId
				);
				if (!assigned) result.push(p);
			});

			return result.sort((a, b) =>
				a.UserFirstName.concat(' ', a.UserLastName).localeCompare(
					b.UserFirstName.concat(' ', b.UserLastName)
				)
			);
		},
	},
};
